import mainImg from '../../assets/images/main-img.jpg';
import '../../common/css/style.css';

// • Коротка інформація про тебе та інших тренерів (фото, досвід, спеціалізація)
// • Особисті досягнення, сертифікації
// • Філософія викладання

export const Teachers = () => {
  return (
    <div id="teachers" className="main-style">
      <div className="teachers-wrapper">
        <img
          src={mainImg}
          alt="Тренери хореографічної студії «Мрія» з учнями"
          className="teachers-image"
          loading="lazy"
        />
        <div className="container-wrapper">
          <section className="container">
            <h2 className="container-title">Викладачі</h2>
            <p>
              Наш дует — Федоренчік Максим Олександрович і Макарова Анна
              Романівна. Діючі професійні танцівники, які перетворюють кожне
              заняття на крок до великої мети.
            </p>

            <ul className="feature-list">
              <li>🎓 Вища хореографічна освіта — випускники Харківської державної академії культури</li>
              <li>🏆 Чемпіони, призери та фіналісти змагань міжнародного та всеукраїнського рівнів</li>
              <li>🥇 Кандидати в майстри спорту, у танцях — понад 20 років</li>
              <li>👨‍👩‍👧 Досвід роботи з дітьми та дорослими — понад 7 років</li>
              <li>📚 Постійно підвищуємо рівень на зборах із педагогами світового класу</li>
            </ul>

            <p>
              Наш досвід і досягнення — запорука серйозної підготовки без
              втрати тепла й турботи. Ми прагнемо передати учням не лише
              техніку, а й справжню любов до танцю.
            </p>

            <a href="/#contacts" className="cta-link">
              Познайомитись особисто <span aria-hidden="true">→</span>
            </a>
          </section>
        </div>
      </div>
    </div>
  );
};
